import React, { useEffect } from 'react'
import Button from '@shared/Button/Button'
import { ElementSizeType } from '@styles/theme-const'
import { useRouter } from 'next/router'
import * as S from './ErrorPage.styled'
import ym from 'react-yandex-metrika'

const ErrorPage = () => {
    const router = useRouter()
    useEffect(() => {
        try {
            if (ym) ym('reachGoal', 'UnknownError')
        } catch (e) {}
    }, [])
    return (
        <S.Container>
            <S.Body>
                <S.TextError>Произошла неизвестная ошибка</S.TextError>
                <Button elementSizeTypeValue={ElementSizeType.large} clickHandler={() => router.reload()}>
                    Перезагрузить страницу
                </Button>
                <Button elementSizeTypeValue={ElementSizeType.large} clickHandler={() => router.push('/')}>
                    вернуться на главную
                </Button>
            </S.Body>
        </S.Container>
    )
}

export default ErrorPage
